<template>
  <div class="hello">
   <div class="top">
    <img src="@/assets/futurestar2026/banner.jpg">
   </div>
    <el-row>
      <el-col>
          <div class="intro">
            <div class="intro-content">
    <p>第26届“未来之星”—— 2026年度“21家高成长性创新企业”征集活动开始了。
</p>
    <p>今年我们将继续在全国范围内寻找成立10年以内、兼具高成长性与硬核创新力的优质初创企业，挖掘中国创业赛道中，有望成长为行业标杆、引领产业未来发展的新生代商业力量。
</p>
    <p>自2001年启动以来，该活动已持续深耕二十五年，累计收录525家创新企业。早期阶段的腾讯、百度、美团、小红书等一众行业龙头，都曾是“未来之星”。近两年，宇树科技、DeepSeek等前沿科技企业，也相继进入“未来之星”数据名单。依托长期产业追踪与客观研判，《中国企业家》持续记录、见证中国商业的迭代升级与创新活力。
</p>
    <p>今年，我们再度携手国内头部投资机构和投资人，结合产业一线视角、客观数据分析与媒体深度观察，锚定代表未来的商业新势力。</p>
  </div>
    </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <a href="/collect" class="baomin"><img src="@/assets/futurestar2026/baoming-but.jpg" alt="评审团"></a>
      
       <img src="@/assets/futurestar2026/lastwlzx-title.jpg" alt="往届未来之星代表企业" class="img_s">
        <div class="content_s clearfix">
             <div class="jg-list clearfix">
        <div class="el-card1">
          
          <img src="@/assets/futurestar2026/supporters/wlzx-1tengxun.jpg" class="image">
        <b>第3届</b>  
        </div>
          <div class="el-card1">
               
          <img src="@/assets/futurestar2026/supporters/wlzx-2baidu.jpg" class="image">
         <b>第5届</b> 
        </div>
         <div class="el-card1">
          <img src="@/assets/futurestar2026/supporters/wlzx-3kdxf.jpg" class="image">
           <b>第6届</b>
        </div>
         <div class="el-card1">
            
          <img src="@/assets/futurestar2026/supporters/wlzx-4jd.jpg" class="image">
          <b>第8届</b> 
        </div>
          <div class="el-card1">
          <img src="@/assets/futurestar2026/supporters/wlzx-5zfb.jpg" class="image">
              <b>第9届</b> 
        </div>
                <div class="el-card1">
                    
          <img src="@/assets/futurestar2026/supporters/wlzx-6mt.jpg" class="image">
          <b>第13届</b> 
        </div>   
           <div class="el-card1">
             
          <img src="@/assets/futurestar2026/supporters/wlzx-7xm.jpg" class="image">
           <b>第13届</b> 
        </div> 
           <div class="el-card1">
           
          <img src="@/assets/futurestar2026/supporters/wlzx-8bli.jpg" class="image">
             <b>第16届</b>  
        </div> 
           <div class="el-card1">
             
          <img src="@/assets/futurestar2026/supporters/wlzx-9wl.jpg" class="image">
           <b>第17届</b>  
        </div> 
           <div class="el-card1">
                
          <img src="@/assets/futurestar2026/supporters/wlzx-10xhs.jpg" class="image">
        <b>第18届</b> 
        </div> 
           <div class="el-card1">
               
          <img src="@/assets/futurestar2026/supporters/wlzx-shein.jpg" class="image">
         <b>第22届</b>  
        </div> 
           <div class="el-card1">
               
          <img src="@/assets/futurestar2026/supporters/wlzx-12deepseek.jpg" class="image">
         <b>第25届</b>  
        </div>      
          </div>
          </div>
      
      
        <img src="@/assets/futurestar2026/pst-title.jpg" alt="评审团" class="img_s">
       <div class="content_s clearfix">
           <p style="font-size: 12px; text-align: right; margin: 0px auto 10px;">备注：按姓名首字母排序</p>
       <div class="pw-list clearfix">
    
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-chenweiguang.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">陈维广</h3>
        <p>蓝驰创投管理合伙人</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-dengfeng.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">邓锋</h3>
        <p>北极光创投创始管理合伙人</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-fangaizhi.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">方爱之</h3>
        <p>真格基金创始合伙人、CEO</p>
        </div>
    </div>
    
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-heyu.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">何愚</h3>
        <p>黑蚁资本管理合伙人</p>
        </div>
    </div>
    
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-huangmingming.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">黄明明</h3>
        <p>明势资本创始合伙人</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-jiangke.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">蒋科</h3>
        <p>泰合资本管理合伙人兼联席CEO</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-jinming.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">金明</h3>
        <p>高鹄资本管理合伙人</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-kuangziping.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">邝子平</h3>
        <p>启明创投创始主管合伙人</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-lifeng.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">李丰</h3>
        <p>峰瑞资本创始合伙人</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-liliang.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">李良</h3>
        <p>高瓴创始合伙人</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-liwei.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">厉伟</h3>
        <p>松禾资本创始合伙人</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-liuerhai.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">刘二海</h3>
        <p>愉悦资本创始及执行合伙人</p>
        </div>
    </div>
    
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-maochengyu.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">毛丞宇</h3>
        <p>云启资本创始合伙人</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-milei.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">米磊</h3>
        <p>中科创星创始合伙人</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-wangwei.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">王玮</h3>
        <p>德弘资本董事总经理</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-wanglin.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">王霖</h3>
        <p>鼎晖投资创始合伙人</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-wuxi.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">邬曦</h3>
        <p>达晨财智合伙人、执行总裁、首席投资官</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-xushi.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">徐诗</h3>
        <p>山行资本创始合伙人</p>
        </div>
    </div>
 <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-youjinbai.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">尤劲柏</h3>
        <p>毅达资本董事长</p>
        </div>
    </div>
 
     <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-zhangye.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">张野</h3>
        <p>青山资本创始人</p>
        </div>
    </div>

     <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-zhangzhen.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">张震</h3>
        <p>高榕创投创始合伙人</p>
        </div>
    </div>
<div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-zhenghuanle.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">郑烜乐</h3>
        <p>光源资本创始人、CEO</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-zhoukui.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">周逵</h3>
        <p>红杉中国合伙人</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-zhuxiaohu.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">朱啸虎</h3>
        <p>金沙江创投主管合伙人</p>
        </div>
    </div>
    <div class="el-card">
      <img src="@/assets/futurestar2026/reviewers/pw-zhuyan.jpg" class="image">
      <div style="padding: 0px;">
        <h3 class="card-title">朱岩</h3>
        <p>蔚来资本管理合伙人</p>
        </div>
    </div>
    
  </div>
          </div>
          <img src="@/assets/futurestar2026/zczg-title.jpg" alt="支持机构" class="img_s">
        <div class="content_s clearfix">
           <p style="font-size: 12px; text-align: right; margin: 0px auto 10px;">备注：按机构中文名称首字母排序</p>
       <div class="jg-list clearfix">
        <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-bai.jpg" class="image">
          </div>
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-baidu.jpg" class="image">
          </div>
         <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-5bjg.jpg" class="image">
          </div>
           <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-zhaoxi.jpg" class="image">
          </div>
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-chunhua.jpg" class="image">
          </div>
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-35dc.jpg" class="image">
          </div>
          
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-dh.jpg" class="image">
          </div>
           <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-fengnian.jpg" class="image">
          </div> 
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-fr.jpg" class="image">
          </div> 
           <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-fuxing.jpg" class="image">
          </div> 
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-ghzb.jpg" class="image">
          </div> 
          
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-2gl.jpg" class="image">
          </div> 
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-8gr.jpg" class="image">
          </div> 
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-gyzb.jpg" class="image">
          </div> 
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-haisong.jpg" class="image">
          </div> 
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-heiyi.jpg" class="image">
          </div> 
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-hengxui.jpg" class="image">
          </div> 
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-1hs.jpg" class="image">
          </div> 
         
        
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-20hc.jpg" class="image">
          </div>
           <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-huaying.jpg" class="image">
          </div>
                    <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-7ggv.jpg" class="image">
          </div>
                    <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-6jsj.jpg" class="image">
          </div>
           <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-jingwei.jpg" class="image">
          </div>
          
                    <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-21lc.jpg" class="image">
          </div>
                    <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-9lx.jpg" class="image">
          </div>
         
                    <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-11ms.jpg" class="image">
          </div>
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-12qm.jpg" class="image">
          </div>
                   
                 <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-28qs.jpg" class="image">
          </div>
           <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-qingliu.jpg" class="image">
          </div>
                 <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-sxzb.jpg" class="image">
          </div>
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-shentoukong.jpg" class="image">
          </div>
           <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-shidaibole.jpg" class="image">
          </div>
                 <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-shunwei.jpg" class="image">
          </div>
                 <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-songhe.jpg" class="image">
          </div>
                
                 
                 <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-31tt.jpg" class="image">
          </div>
                 <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-34wl.jpg" class="image">
          </div>
             
          
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-32yk.jpg" class="image">
          </div>
          
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-14yy.jpg" class="image">
          </div>
          <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-ymzb.jpg" class="image">
          </div>
                    <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-10yq.jpg" class="image">
          </div>
                    <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-22zg.jpg" class="image">
          </div>
                    <div class="el-card">
          <img src="@/assets/futurestar2026/supporters/jg-zkcx.jpg" class="image">
          </div>
                  
          </div>
          </div>

        </el-col>
    </el-row>
    <img src="@/assets/futurestar2026/process.jpg" alt="评选流程" style="display: block; margin: 0px auto; width: 100%;float:left">
    <img src="@/assets/futurestar2026/bottom.jpg" alt="底部" style="display: block; margin: 0px auto; width: 100%;">  
  </div>
</template>
<script>
/* global wx */
export default {
  name: 'FutureStar2026',
  data() {
    return {
      shareTitle: '木兰年会',
      shareDesc: '木兰年会进行时',
      shareImg: '@/assets/futurestar2026/share.jpg',
      shareLink: window.location.href.split('#')[0],
      jsSdkLoaded: false,
      wxReady: false,
      wxError: null,
      wechatConfig: null
    }
  },
  mounted() {
    this.initWechatShare()
  },
  methods: {
    loadWxScript() {
      return new Promise((resolve, reject) => {
        if (typeof wx !== 'undefined') {
          this.jsSdkLoaded = true
          return resolve()
        }

        const script = document.createElement('script')
        script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
        script.onload = () => {
          this.jsSdkLoaded = true
          resolve()
        }
        script.onerror = () => reject(new Error('微信 JS-SDK 加载失败'))
        document.head.appendChild(script)
      })
    },

    async initWechatShare() {
      try {
        await this.loadWxScript()

        if (typeof wx === 'undefined') {
          throw new Error('微信 JS-SDK 未加载完成')
        }

        const shareContent = await this.fetchShareContent()
        const shareConfig = await this.fetchShareConfig()

        if (shareContent) {
          if (shareContent.title) {
            this.shareTitle = shareContent.title
          }
          if (shareContent.desc) {
            this.shareDesc = shareContent.desc
          }
          if (shareContent.img) {
            this.shareImg = shareContent.img
          }
          if (shareContent.link) {
            this.shareLink = shareContent.link
          }
        }

        if (!shareConfig) {
          throw new Error('微信分享配置获取失败，无法初始化微信 JS-SDK')
        }

        this.wechatConfig = shareConfig

        console.debug('wechat config data:', this.wechatConfig)
        console.debug('wechat share data:', {
          title: this.shareTitle,
          desc: this.shareDesc,
          link: this.shareLink,
          imgUrl: this.shareImg
        })

        wx.config({
          // debug: false,
          appId: this.wechatConfig.appId,
          timestamp: this.wechatConfig.timestamp,
          nonceStr: this.wechatConfig.nonceStr,
          signature: this.wechatConfig.signature,
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareAppMessage',
            'onMenuShareTimeline',
            'showOptionMenu'
          ]
        })

        wx.ready(() => {
          const shareData = {
            title: this.shareTitle,
            desc: this.shareDesc,
            link: this.shareLink,
            imgUrl: this.shareImg
          }

          wx.updateAppMessageShareData(shareData)
          wx.updateTimelineShareData(shareData)
          wx.onMenuShareAppMessage(shareData)
          wx.onMenuShareTimeline(shareData)
          wx.showOptionMenu()
          this.wxReady = true
        })

        wx.error((err) => {
          console.error('微信 JS-SDK 配置错误：', err)
          this.wxError = err
        })
      } catch (error) {
        console.error('微信分享初始化失败：', error)
        this.wxError = error
      }
    },

    async fetchShareContent() {
      const response = await fetch('/api/2026/getshare', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ url: this.shareLink })
      })

      if (!response.ok) {
        throw new Error(`分享内容接口 HTTP 错误: ${response.status}`)
      }

      const body = await response.json()
      if (body.status !== undefined && body.status !== 0) {
        throw new Error(`分享内容接口返回错误: ${JSON.stringify(body)}`)
      }

      return body.data || body
    },

    async fetchShareConfig() {
      const response = await fetch('/api/2024/getSignature', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ url: this.shareLink })
      })

      if (!response.ok) {
        throw new Error(`分享配置接口 HTTP 错误: ${response.status}`)
      }

      const body = await response.json()
      console.log("999999",body)
      const data = body.data.data || body
      const appId = data.data.appId || data.appid
      const timestamp = data.data.timestamp || data.ts || data.timeStamp
      const nonceStr = data.data.nonceStr || data.noncestr || data.nonceStr
      const signature = data.data.signature || data.sign

      if (!appId || !timestamp || !nonceStr || !signature) {
        throw new Error(`分享配置接口返回参数不完整: ${JSON.stringify(data)}`)
      }

      return { appId, timestamp, nonceStr, signature }
    }
  }
}
</script>
<style lang="less" scoped>
.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.hello {
    background-color: #fce9d9;
    color: #3a0202;
    font-weight: 700;
}
.top{
  position: relative;
  width: 100%;
  height: auto;
}
.top img{
  width: 100%;
  height: auto;
  display: block;
}
.intro{
    position: relative;
    color: #1a1a18;
    font-size: 16px;
    width: 100%;
    background: url(~@/assets/futurestar2026/intro-bg.jpg) 0 0 no-repeat;
    background-size: cover;
    padding: 0;
    height: 430px;
    line-height: 36px;
    text-align: left;
}
.intro-content{
    width: 90%;
    margin: 0 auto;
    height: 400px;
    overflow-y: scroll;
    padding: 20px 5%;
    border-radius: 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: url(~@/assets/futurestar2026/jieshaobg.png) 0 0 no-repeat;
    background-size: cover;
    border: 2px solid #fb5504;
    text-align: justify;
}
.grid-content p{
    text-align: justify;
    margin: 0 0 15px;
}
.intro-bg{
  position: absolute;
  top:0px;
  left: 0px;
}
.intro-content::-webkit-scrollbar {
  /* 滚动条整体样式 */
  width: 12px;
  /* 宽高分别对应横竖滚动条的尺寸 */
  background:#fdbfa1;
  border-radius: 30px;
  -webkit-box-shadow: inset 1px 0 1px #fb5504;
}
.intro-content::-webkit-scrollbar-thumb {
  /* 滚动条里的小方块 */
  border-radius: 30px;
  background: #fb5504;
  
  -webkit-box-shadow: inset 0 0 5px #f3af8d;
  min-height: 10px!important;
}
.intro-content::-webkit-scrollbar-track {
  /* 滚动条里面的轨道 */
  -webkit-box-shadow: inset 0 0 5px #f3af8d;
  border-radius: 10px;
  background: #fdbfa1;
}
.baomin{
    display: block;
    width: 100%;
    padding: 20px 0 40px;
}
.baomin img{
    width: 100%;
    display: block;
}
.content_s{
    padding: 0 6% 50px;
    background-color: #fccbae;
    margin: 0px 0px 20px;
}
.img_s{
  width: 100%;
  display: block;
}

.image{
    width: 100%;
    display: block;
}
.el-card,.el-card1 {
    width: 33.33333%;
    float: left;
    padding: 0 6px 20px;
    border: none;
    background: none;
    color: #000;
    box-sizing: border-box;
}
.el-card1{
  width: 25%;
  position: relative;
}
.el-card1 b{
 
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  text-align: center;
  color:#000;
  width: 90%;
}
.el-card h3, .el-card span{
    font-size: 16px;
    font-weight: 700;
    margin: 10px 0 4px;
    line-height: 18px;
    text-align: center;
}
.el-card span{
    font-size: 14px;
    line-height: 18px;
    display: block;
    margin: 0;
    font-weight: 400;
}
.pw-list,.jg-list{
    width: 100%;
    display: block;
}
.card-title{
      font-size: 14px;
    font-weight: 700;
    margin: 10px 0 4px;
    line-height: 18px;
    text-align: center;
}
.el-card p{
    font-size: 12px;
    line-height: 18px;
    display: block;
    margin: 0;
    font-weight: 400;
}
.el-card:nth-child(3n+1){clear: left;
}
</style>